import * as React from "react";
import { ColumnConfig } from "app/components/AppComponents/ConfigurableTable";
import BackOfficeAndSnapminLink from "app/components/BOComponents/BackOfficeAndSnapminLink";

const columnConfigs: ColumnConfig[] = [
  {
    name: "Id",
    render: row => row.id
  },
  {
    name: "Name",
    render: row => {
      return (
        <BackOfficeAndSnapminLink
          backofficeUrl={`/snapscan/ops/biller_categories/billers/${row.id}`}
          snapminUrl={row.snapmin_url}
        >
          {row.name}
        </BackOfficeAndSnapminLink>
      );
    }
  },
  {
    name: "Title",
    render: row => {
      return (
        <BackOfficeAndSnapminLink
          backofficeUrl={`/snapscan/ops/user_messaging/${row.id}/summary`}
          snapminUrl={row.snapmin_url}
        >
          {row.title}
        </BackOfficeAndSnapminLink>
      );
    }
  },
  {
    name: "Provider",
    render: row => row.provider
  },
  {
    name: "Placeholder",
    render: row => row.placeholder
  },
  {
    name: "Enabled",
    render: row => row.enabled
  },
  {
    name: "Logo",
    render: row => {
      return (
        <div className="small-icon">
          <img className="match-parent" alt="No icon" src={row.logo} />
        </div>
      );
    }
  },
  {
    name: "Last updated",
    render: row => row.updated_at
  }
];

export default columnConfigs;
